import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="px-6 md:px-12 lg:px-20 py-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="bg-foreground-950 rounded-2xl px-8 md:px-14 py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">OOPBUY Spreadsheet</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-xs">
                Die unabhängige deutsche Informationsplattform für OOPBUY Spreadsheet. Produktlisten, Verkäufervergleiche und Shopping-Tipps für Deutschland, Österreich und die Schweiz.
              </p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-900 text-sm font-semibold rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
              >
                oopbuy spreadsheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
            </div>

            <div>
              <h4 className="text-white/60 text-xs font-semibold uppercase tracking-wider mb-5 whitespace-nowrap">Navigation</h4>
              <nav className="flex flex-col gap-3">
                <Link to="/" className="text-white/70 text-sm hover:text-white transition-colors whitespace-nowrap">Startseite</Link>
                <a href="#categories" className="text-white/70 text-sm hover:text-white transition-colors whitespace-nowrap">Kategorien</a>
                <Link to="/oopbuy-spreadsheet-guide" className="text-white/70 text-sm hover:text-white transition-colors whitespace-nowrap">Shopping Guide</Link>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/70 text-sm hover:text-white transition-colors whitespace-nowrap">Zum Hauptportal</a>
              </nav>
            </div>

            <div>
              <h4 className="text-white/60 text-xs font-semibold uppercase tracking-wider mb-5 whitespace-nowrap">SEO Guides</h4>
              <nav className="flex flex-col gap-2">
                <Link to="/oopbuy-sicherheit" className="text-white/60 text-xs hover:text-white transition-colors whitespace-nowrap">OOPBUY Sicherheit</Link>
                <Link to="/oopbuy-versand" className="text-white/60 text-xs hover:text-white transition-colors whitespace-nowrap">Versand Deutschland</Link>
                <Link to="/oopbuy-qc-guide" className="text-white/60 text-xs hover:text-white transition-colors whitespace-nowrap">QC Guide</Link>
                <Link to="/oopbuy-vergleich" className="text-white/60 text-xs hover:text-white transition-colors whitespace-nowrap">Plattform Vergleich</Link>
                <Link to="/oopbuy-anfaenger" className="text-white/60 text-xs hover:text-white transition-colors whitespace-nowrap">Anfänger Guide</Link>
                <Link to="/oopbuy-trendprodukte" className="text-white/60 text-xs hover:text-white transition-colors whitespace-nowrap">Trendprodukte 2026</Link>
                <Link to="/oopbuy-verkaufer" className="text-white/60 text-xs hover:text-white transition-colors whitespace-nowrap">Verkäufer finden</Link>
                <Link to="/oopbuy-kosten-sparen" className="text-white/60 text-xs hover:text-white transition-colors whitespace-nowrap">Kosten sparen</Link>
                <Link to="/oopbuy-faq" className="text-white/60 text-xs hover:text-white transition-colors whitespace-nowrap">FAQ Sammlung</Link>
              </nav>
            </div>

            <div>
              <h4 className="text-white/60 text-xs font-semibold uppercase tracking-wider mb-5 whitespace-nowrap">Kontakt</h4>
              <div className="flex flex-col gap-2 mb-8">
                <a href="mailto:info@oopbuyspread.baby" className="text-white/70 text-sm hover:text-white transition-colors whitespace-nowrap">info@oopbuyspread.baby</a>
              </div>
              <h4 className="text-white/60 text-xs font-semibold uppercase tracking-wider mb-5 whitespace-nowrap">Adresse</h4>
              <p className="text-white/50 text-sm leading-relaxed">
                OOPBUY Spreadsheet<br />
                Deutschland
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-5">
                            <a href="https://x.com" target="_blank" rel="noopener nofollow" className="text-white/40 hover:text-white/70 transition-colors text-xs whitespace-nowrap">X (Twitter)</a>
              <a href="https://instagram.com" target="_blank" rel="noopener nofollow" className="text-white/40 hover:text-white/70 transition-colors text-xs whitespace-nowrap">Instagram</a>
              <a href="https://pinterest.com" target="_blank" rel="noopener nofollow" className="text-white/40 hover:text-white/70 transition-colors text-xs whitespace-nowrap">Pinterest</a>
            </div>
            <p className="text-white/30 text-xs whitespace-nowrap">
              &copy; 2026 OOPBUY Spreadsheet. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-5">
              <Link to="/oopbuy-sicherheit" className="text-white/40 hover:text-white/70 transition-colors text-xs whitespace-nowrap">Datenschutz</Link>
              <a href="mailto:info@oopbuyspread.baby" className="text-white/40 hover:text-white/70 transition-colors text-xs whitespace-nowrap">Impressum</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}